import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
// trigger redeploy Wed Aug 19 12:35:07 UTC 2026
